var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircle1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.75C13.1421 16.75 16.5 13.3921 16.5 9.25C16.5 5.10786 13.1421 1.75 9 1.75C4.85786 1.75 1.5 5.10786 1.5 9.25C1.5 13.3921 4.85786 16.75 9 16.75ZM9.76958 7.20622C9.59163 7.08127 9.3901 6.95201 9.18145 6.82513C8.37715 6.33603 7.975 6.09148 7.61431 6.36223C7.25363 6.63299 7.22085 7.1998 7.15529 8.33342C7.13675 8.65401 7.125 8.96829 7.125 9.25003C7.125 9.53178 7.13675 9.84606 7.15529 10.1666C7.22085 11.3003 7.25363 11.8671 7.61431 12.1378C7.975 12.4086 8.37715 12.164 9.18145 11.6749C9.3901 11.5481 9.59163 11.4188 9.76958 11.2938C9.97242 11.1514 10.1932 10.9805 10.4157 10.7989C11.2219 10.1413 11.625 9.81245 11.625 9.25003C11.625 8.68762 11.2219 8.35879 10.4157 7.70114C10.1932 7.51959 9.97242 7.34866 9.76958 7.20622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle1);
export default __webpack_public_path__ + "static/media/PlayCircle1.db87fbd46b15720cfdaed250473c0cde.svg";
export { ForwardRef as ReactComponent };